import React, { useState, useEffect } from "react";
import "../CoinsAllotments/CoinAllotmentList.css";
import { FaEdit, FaTrash } from "react-icons/fa";
import CoinAllotHeader from "./CoinAllotmentHeader/CoinAllotHeader";
import CoinAllotmentListHeader from "./CoinAllotmentListHeader";
import DeletePopup from "../../Component/DeletePopup/DeletePopup";
import Spinner from "../../Component/Spinner/Spinner";
import ConfirmPopup from "../../Component/ConfirmPopup/ConfirmPopup";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import EditCoinOverlay from "./EditCoinAllotOverlay/EditCoinOverlay";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import { APP_VERSION } from "../Version Provider/VersionConfig";

const columnToApiMap = {
    transactionNo: "TransNo",
    datetime: "TransDate",
    billInfo: "BillInfo",
    customer: "CustName",
    coins: "TransValue",
    transactionremarks: "TransDesc",
    user: "CreatedByAdminName",
    status: "Status",
    companyName: "CompName",
    createdBy: "CreateBy",
    lastUpdated: "LastUpdate",
};

const CoinAllotmentList = () => {
    const [globalSearch, setGlobalSearch] = useState("");
    const [columnSearch, setColumnSearch] = useState({
        transactionNo: "",
        datetime: "",
        customer: "",
        coins: "",
        transactionremarks: "",
        user: "",
        status: "active",
        type: "",
        transstartDate: "",
        lastUpdatedStartDate:""
    });
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editCoinAllot, setEditCoinAllot] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    //version control state
    const [versionCode] = useState(APP_VERSION);
    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "success",
    });
    const [sortState, setSortState] = useState({
        column: "datetime",
        order: "desc",
    });
    const [totals, setTotals] = useState({
        allotted: 0,
        deducted: 0,
        net: 0,
    });
    const navigate = useNavigate();
    const limit = 20;

    const fetchCoinAllotments = async (pageNum = 1) => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const startfrom = (pageNum - 1) * limit;
            const apiSortColumn =
                columnToApiMap[sortState.column] || "TransDate";
            const apiSortOrder = sortState.order === "asc" ? 1 : -1;

            const payload = {
                startfrom,
                limit,
                VersionCode: versionCode,
                transNo: columnSearch.transactionNo || "",
                billInfo: columnSearch.billInfo || "",
                custName: columnSearch.customer || "",
                transValue: columnSearch.coins || "",
                transDesc: columnSearch.transactionremarks || "",
                createdByAdminName: columnSearch.user || "",
                custMobile: columnSearch.mobile?.trim() || "",
                searchstring: globalSearch || "",
                status:
                    columnSearch.status === "active"
                        ? "ACTIVE"
                        : columnSearch.status === "deactive"
                          ? "Deactive"
                          : "",

                transDateStartDate: columnSearch.transstartDate
                    ? formatIndianDate(new Date(columnSearch.transstartDate))
                    : "",
                transDateEndDate: columnSearch.transendDate
                    ? formatIndianDate(new Date(columnSearch.transendDate))
                    : "",
                lastUpdateStartDate: columnSearch.lastUpdatedStartDate
                    ? formatIndianDate(new Date(columnSearch.lastUpdatedStartDate))
                    : "",
                lastUpdateEndDate: columnSearch.lastUpdatedEndDate
                    ? formatIndianDate(new Date(columnSearch.lastUpdatedEndDate))
                    : "",

                transType:
                    columnSearch.type === "Allot"
                        ? "IN"
                        : columnSearch.type === "Deduct"
                          ? "OUT"
                          : "",

                SortColumn: apiSortColumn,
                SortOrder: apiSortOrder,
            };

            const res = await axios.post(Api.getCoinAllot, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (
                res.data.status === 0 &&
                res.data.message &&
                res.data.message.toLowerCase().includes("version")
            ) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {res.data.message}
                        </>
                    ),
                    type: "error",
                });
                return;
            }
            if (res.data.status === 1 && Array.isArray(res.data.data)) {
                let allotments = res.data.data.map((item, index) => ({
                    id: item._id,
                    transactionNo: item.TransNo,
                    datetime: item.TransDate
                        ? formatIndianDate(new Date(item.TransDate))
                        : "",
                    entryDate: item.CreatedAt
                        ? formatIndianDate(new Date(item.CreatedAt))
                        : "",
                    lastUpdated: item.LastUpdate
                        ? formatIndianDate(new Date(item.LastUpdate),true)
                        : "",
                    customer: item.CustName,
                    CustMobile: item.CustMobile,
                    coins: item.TransValue,
                    TransType: item.TransType,
                    transactionremarks: item.TransDesc,
                    billInfo: item.BillInfo,
                    user: item.CreatedByAdminName,
                    status: item.Status,
                    sr: startfrom + index + 1,
                }));

                // Calculate page-wise totals
                const pageAllotted = res.data.data
                    .filter((i) => i.TransType === "IN")
                    .reduce((sum, i) => sum + Number(i.TransValue || 0), 0);
                const pageDeducted = res.data.data
                    .filter((i) => i.TransType === "OUT")
                    .reduce((sum, i) => sum + Number(i.TransValue || 0), 0);

                // Update totals cumulatively
                setTotals((prev) => ({
                    allotted:
                        pageNum === 1
                            ? pageAllotted
                            : prev.allotted + pageAllotted,
                    deducted:
                        pageNum === 1
                            ? pageDeducted
                            : prev.deducted + pageDeducted,
                    net:
                        pageNum === 1
                            ? pageAllotted - pageDeducted
                            : prev.net + (pageAllotted - pageDeducted),
                }));

                // Merge data with existing
                setData((prev) =>
                    pageNum === 1 ? allotments : [...prev, ...allotments],
                );

                if (allotments.length < limit) setHasMore(false);
            } else {
                setHasMore(false);
            }
        } catch (err) {
            console.error("Error fetching coin allotments:", err);
            setPopup({
                show: true,
                message:
                    err.response?.data?.message || "Failed to fetch records.",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };
    const handleSortChange = (column, order) => {
        setSortState({ column, order });
        setData([]);
        setPage(1);
        setHasMore(true);
    };

    useEffect(() => {
        setLoading(true);

        setData([]);
        setPage(1);
        setHasMore(true);
        const handler = setTimeout(() => {
            fetchCoinAllotments(1).finally(() => {
                setLoading(false);
            });
        }, 300);
        return () => clearTimeout(handler);
    }, [globalSearch, columnSearch, sortState]);

    const fetchMoreData = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchCoinAllotments(nextPage);
    };

    const handleEditClick = (row) => {
        setEditCoinAllot(row);
        setShowEditModal(true);
    };

    const handleDeleteClick = (id) => {
        setSelectedId(id);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const res = await axios.post(
                Api.editCoinAllot,
                { _id: selectedId, Status: "Deactive" },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (res.data.status === 1) {
                setPopup({
                    show: true,
                    message: "Record deactivated successfully!",
                    type: "success",
                });
                setShowDeleteModal(false);
                setSelectedId(null);
                setData([]);
                setPage(1);
                setHasMore(true);
                fetchCoinAllotments(1);
            } else {
                setPopup({
                    show: true,
                    message: res.data.message || "Failed to deactivate record.",
                    type: "error",
                });
            }
        } catch (err) {
            console.error("Error deactivating record:", err);
            setPopup({
                show: true,
                message:
                    err.response?.data?.message || "Error deactivating record",
                type: "error",
            });
        } finally {
            setShowDeleteModal(false);
            setSelectedId(null);
        }
    };

    const handlePopupClose = () => setPopup({ ...popup, show: false });

    return (
        <div className="coinallot-table-container">
            <CoinAllotHeader
                search={globalSearch}
                setSearch={setGlobalSearch}
                columnSearch={columnSearch}
                setColumnSearch={setColumnSearch}
                onRefresh={() => {
                    setSortState({ column: "datetime", order: "desc" });
                    setData([]);
                    setPage(1);
                    setHasMore(true);
                    // fetchCoinAllotments(1);
                }}
                totals={totals}
            />

            <div className="coinallot-table-wrapper" id="scrollableDiv">
                <CoinAllotmentListHeader
                    columnSearch={columnSearch}
                    setColumnSearch={setColumnSearch}
                    currentSortColumn={sortState.column}
                    currentSortOrder={sortState.order}
                    onSortChange={handleSortChange}
                />

                {loading && page === 1 ? (
                    <Spinner />
                ) : data.length > 0 ? (
                    <InfiniteScroll
                        dataLength={data.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={<Spinner />}
                        endMessage={
                            <div className="no-data">No more records</div>
                        }
                        scrollableTarget="scrollableDiv"
                        style={{ overflow: "visible" }}
                    >
                        {data.map((row, index) => (
                            <div className="coinallot-table-row" key={row.id}>
                                <div className="coinallot-table-cell">
                                    {index + 1}
                                </div>
                                <div className="coinallot-table-cell">
                                    <div className="coinallot-action-icons">
                                        <button
                                            className="edit"
                                            onClick={() => handleEditClick(row)}
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            className="delete"
                                            onClick={() =>
                                                handleDeleteClick(row.id)
                                            }
                                        >
                                            <FaTrash />
                                        </button>
                                    </div>
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.transactionNo}
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.datetime}
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.lastUpdated}
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.billInfo}
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.customer}
                                </div>
                                <div
                                    className={`coinallot-table-cell ${
                                        row.TransType === "IN"
                                            ? "coinallot-coins-positive"
                                            : "coinallot-coins-negative"
                                    }`}
                                >
                                    {row.TransType === "IN"
                                        ? `+ ${row.coins}`
                                        : `- ${row.coins}`}
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.transactionremarks}
                                </div>
                                <div className="coinallot-table-cell">
                                    {row.user}
                                </div>
                                <div className="coinallot-table-cell">
                                    <div
                                        className={`status-badge-coinallot ${
                                            row.status?.toLowerCase() === "active" ? "active" : "deactive"
                                        }`}
                                    >
                                        {row.status?.toLowerCase() === "active" ? "Active" : "Deactive"}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </InfiniteScroll>
                ) : (
                    <div className="no-data">
                        {loading ? "Searching records..." : "No more records"}
                    </div>
                )}
            </div>
            {showEditModal && editCoinAllot && (
                <EditCoinOverlay
                    coinData={editCoinAllot}
                    onClose={() => setShowEditModal(false)}
                    onSave={() => {
                        setShowEditModal(false);
                        setData([]);
                        setPage(1);
                        setHasMore(true);
                        fetchCoinAllotments(1);
                    }}
                />
            )}
            <DeletePopup
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={confirmDelete}
            />

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default CoinAllotmentList;
